import { createSelector } from 'reselect';
import { getProductionScheduleEnabled } from './getProductionScheduleEnabled';

const getSelectWorkOrderOp = (state) => {
  return state.selectWorkOrderOp;
};

export const getSelectWorkOrderOpOpen = (state) => {
  return state.selectWorkOrderOp.open;
};

export const getSelectWorkOrderOpOptions = createSelector(
  [getSelectWorkOrderOp, getProductionScheduleEnabled],
  ({ options }, productionScheduleEnabled) => {
    const {
      isSearchMode,
      onlyMachineChecked,
      onlyAssignedChecked,
      search,
      nextStep,
    } = options;
    const onlyMachineCheckedDisabled =
      !isSearchMode && !productionScheduleEnabled;

    // The visible toggle: "Assigned jobs only" in search mode, else "Scheduled jobs only".
    return {
      ...options,
      isSearchMode,
      onlyMachineChecked: isSearchMode
        ? onlyAssignedChecked
        : !onlyMachineCheckedDisabled && onlyMachineChecked,
      search: isSearchMode ? search : '',
      nextStep,
    };
  }
);
